import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function AvatarConsultantSection({
  onPress,
}: {
  onPress: () => void
}) {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['configuration'])
  const text = 'configuration:start.sections.consultant'

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          classNameDesc={Platform.select({ default: 'pr-16', web: 'w-2/3' })}
          glassProps={{
            className: 'overflow-hidden-fixer',
            animation,
            magicGlow: true,
            image: require('@/images/avatar/robot.png'),
            imageWrapperStyle: {
              transformOrigin: 'bottom right',
              transform: [
                { scale: Platform.select({ default: 0.66, web: 0.75 }) },
              ],
            },
            imageStyle: {
              transform: [
                { translateX: Platform.select({ default: -50, web: -75 }) },
                { translateY: Platform.select({ default: -75, web: -50 }) },
              ],
            },
            blur: Platform.select({ default: 150, web: 50 }),
            blurStyle: {
              opacity: 0.5,
              transformOrigin: 'center',
              transform: [
                { translateX: 0 },
                { translateY: 20 },
                { scale: 0.5 },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
